import { RootState } from 'reduxStore/types';

export const getInitialCustomerRepresentativeFilters = (state: RootState) =>
  state?.orders.customerRepresentativeFilters;
